import React, { createContext, FC, ReactNode, useCallback, useContext, useMemo, useState } from 'react'
import AppSnackbar, { SnackbarState } from '../components/AppSnackbar'

type SnackbarContextType = {
  showSnackbar: (message: string, severity: NonNullable<SnackbarState>['severity']) => void
}

const SnackbarContext = createContext<SnackbarContextType>({
  showSnackbar: () => {},
})

export const SnackbarProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [snackbar, setSnackbar] = useState<SnackbarState>(null)

  const showSnackbar = useCallback((message: string, severity: NonNullable<SnackbarState>['severity']) => {
    setSnackbar({ message, severity })
  }, [])

  const value = useMemo(() => ({ showSnackbar }), [showSnackbar])

  return (
    <SnackbarContext.Provider value={value}>
      {children}
      <AppSnackbar snackbar={snackbar} onClose={() => setSnackbar(null)} />
    </SnackbarContext.Provider>
  )
}

export const useSnackbar = () => useContext(SnackbarContext)
